import type { SetStateAction } from 'react';
import React from 'react';

export const ChartCardContext = React.createContext<{
  /** Is the data being fetched for the summary part of the card? */
  isLoadingSummary?: boolean;
  /** Is the data being fetched for the details part of the card? */
  isLoadingDetails?: boolean;
  /** minimal (half size - landing) or not (full size - chart page) */
  minimal?: boolean;
  /** Is the card currently playing? */
  isPlaying?: boolean;
  /**
   * Initial state for the card to be expanded or not.
   *
   * @note Only useful for non-minimal cards with size mobile
   */
  expandedId?: string | null;
  /**
   * Setter for the expanded state.
   *
   * @note Only useful for non-minimal cards with size mobile
   */
  setExpandedId?: (id: string | null) => void;
  /**
   * Setter for the loading state of chart card details.
   *
   * @note Useful to show loading state while fetching data for the details part of the card.
   */
  setIsLoadingDetails?: React.Dispatch<SetStateAction<boolean>>;
}>({
  isLoadingSummary: false,
  isLoadingDetails: false,
  isPlaying: false,
  minimal: false,
  expandedId: null,
  setExpandedId: () => null,
});

export function useChartCardContext() {
  const context = React.useContext(ChartCardContext);
  if (!context) {
    throw new Error(
      `ChartCard compound components cannot be rendered outside the ChartCard component`,
    );
  }

  return context;
}
